const annotationSelectionConstants = {
  CLEAR_SELECTION: 'ANNOTATION_SELECTION_CLEAR_SELECTION',
  SELECT: 'ANNOTATION_SELECTION_SELECT',
  SET_ANNOTATION_CONTEXT: 'ANNOTATION_SELECTION_SET_ANNOTATION_CONTEXT',
  SET_CLICKED_ENTITY: 'ANNOTATION_SELECTION_SET_CLICKED_ENTITY',
  SET_DEFAULT_COLOR: 'ANNOTATION_SELECTION_SET_DEFAULT_COLOR',
  SET_SELECTABLE_TYPE: 'ANNOTATION_SELECTION_SET_SELECTABLE_TYPE',
  START_DRAWING: 'ANNOTATION_SELECTION_START_DRAWING',
  TRACK_CURSOR: 'ANNOTATION_SELECTION_TRACK_CURSOR',
  TRACK_RESET: 'ANNOTATION_SELECTION_TRACK_RESET'
};
export default annotationSelectionConstants;